
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './form-container.component.scss';

import * as _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap-datepicker';

export class FormContainer extends Base {

	form: HTMLFormElement;
	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;

	pagerHomeButtonContainer: Element;
	pagerHomeButton: Element;

	pagerHomePage: Element;
	pagerPages: Element[];
	pagePageToggles: Element[];
	formDatePicker: Element;
	formTimePicker: Element;
	_startDate: Date;

	publicHolidays: any[];

	_currencyFields: any[];

	constructor(element: Element) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.modals = Array.from(this.element.querySelectorAll('.js-apply-now-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-apply-now-modal-open'));
		this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
		this.pagerPages = Array.from(this.element.querySelectorAll('.js-pager-page'));
		this._currencyFields = Array.from(this.element.querySelectorAll('.form__input--currency'));

		this.publicHolidays = ['2019/09/24', '2019/12/16', '2019/12/25', '2019/12/26', '2020/01/01', '2020/03/21', '2020/04/10', '2020/04/13', '2020/04/27', '2020/05/01', '2020/06/16', '2020/08/10', '2020/09/24', '2020/12/16', '2020/12/25', '2020/12/26'];

		// DATE PICKER
		$(document).ready(function () {
			$('input.js-date-picker').datepicker({
				todayHighlight: true,
				format: 'yyyy/mm/dd',
				daysOfWeekDisabled: [0, 6],
				enableOnReadonly: true,
				autoclose: true
			}).on('changeDate', function (event) {
				let _event;
				if (typeof window.event == "function") {
					_event = new Event('change');
					this.dispatchEvent(_event);
				} else {
					_event = document.createEvent('HTMLEvents');
					_event.initEvent('change', false, false);
					this.dispatchEvent(_event);
				}
			});
		})
		TooltipsService.initTooltips();
	}

	bindEvents() {
		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.closeButton.addEventListener('click', (event) => this.closeModal());

		// this.modalLinks.map((item) => item.addEventListener('click', (event) => {
		// 	this.openModals(event);
		// }));

		// Changed the way this works for dynamic content - Malcolm 14-02-2018

		document.addEventListener('click', (e: any) => {
			let composedPath = (el) => {

				let path = [];

				while (el) {

					path.push(el);

					if (el.tagName === 'HTML') {

						path.push(document);
						path.push(window);

						return path;
					}

					el = el.parentElement;
				}
			}

			let path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
			let hasClass = (cls: string) => {

				return _.filter(path, (p) => {

					let exists = false;
					_.each(p.classList, (cl) => {

						if (cl === cls) {
							exists = true
						}

					})

					if (p.classList && exists) {
						return p;
					}

				})[0];

			}

			if (hasClass('js-apply-now-modal-open')) {

				this.openModals(e);

			}

		}, false);

	}

	isClickOutsideModal(event) {

		if (event.target === this.activeModal) {
			this.closeModal();
		}

	}

	openModals(event) {
		let element: Element = event.target;
		let modalId = element.getAttribute('data-modal');
		if (!modalId) {
			let parentElement = $(element).closest('.js-apply-now-modal-open');
			modalId = parentElement.attr('data-modal');
		}

		this.activeModal = this.getModalById(modalId);
		this.openModal();

	}

	closeModal() {

		this.analyticsService.dtmFormAbandon();
		this.activeModal.classList.add('modal--close');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

	}

	openModal() {
		if (this.activeModal) {
			this.formDatePicker = this.activeModal.querySelector('.js-date-picker');
			this.formTimePicker = this.activeModal.querySelector('.js-time-picker');
			if (this.formDatePicker) {
				this.formDatePicker.addEventListener('change', (event) => {
					this.validateDate(event.target);
				});
				if (this.formTimePicker) {
					this.formDatePicker.classList.remove("form__input--required");
					this.formTimePicker.addEventListener('change', (event: any) => {
						if (event.currentTarget.value == "Anytime") {
							this.formDatePicker.classList.remove("form__input--required");
						}
						else {
							this.formDatePicker.classList.add("form__input--required");
						}
					});
				}
			}

			this.resetForm();
			this.populateDatePicker();
			this.activeModal.classList.remove('modal--close');
			this.activeModal.classList.remove('modal--closed');
		}
	}

	getModalById(id) {
		return document.querySelector(`#${id}`);
	}

	togglePages(event) {

		this.pagerHomePage.classList.add('apply-now__page--hidden');
		this.pagerHomeButtonContainer.classList.add('apply-now__home-button-container--visible');

		this.hidePages();

		let goToPage = event.currentTarget.getAttribute('data-target');
		this.element.querySelector(`#${goToPage}`).classList.remove('apply-now__page--hidden');

	}

	hidePages() {

		for (let i = 0; i < this.pagerPages.length; i++) {
			this.pagerPages[i].classList.add('apply-now__page--hidden');
		}

	}

	showHomePage() {

		this.hidePages();

		this.pagerHomePage.classList.remove('apply-now__page--hidden');
		this.pagerHomeButtonContainer.classList.remove('apply-now__home-button-container--visible');

	}

	resetForm() {

		if (this.form) {

			this.form.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');

			if (formContainerLoader) {
				formContainerLoader.classList.remove('active');
			}
			if (formContainerFields) {
				formContainerFields.classList.remove('hidden');
			}
			if (formContainerThankyou) {
				formContainerThankyou.classList.remove('active');
			}

			// allow individual form items components to handle form reset
			const event = new CustomEvent('custom_form_reset_event');
			this.form.dispatchEvent(event);
		}

	}

	populateDatePicker() {
		if (this.formDatePicker) {
			this._startDate = this.validateDate();
			$(this.formDatePicker).datepicker('setStartDate', this._startDate).datepicker('setDatesDisabled', this.publicHolidays);
		}
	}

	validateDate(_setDate: any = '') {
		if (this.formTimePicker) {
			let _enabledOptions = false;
			const _currentDateTime = new Date();
			let _currentHour = _currentDateTime.getHours();
			let _currentMin = _currentDateTime.getMinutes();

			if (_setDate != '') {
				const _selectedDate = new Date(_setDate.value);
				const _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
				const _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();

				_currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());

				if (_tmpSelectedDate != _tmpCurrentDate) {
					_currentHour = 7;
					_currentMin = 0;
					_enabledOptions = true;
				}
				else {
					_enabledOptions = false;
				}

			}

			if (_currentHour >= 16) {
				_currentDateTime.setDate(_currentDateTime.getDate() + 1)
				_currentHour = 7;
				_currentMin = 0;
			}
			if ((_currentMin >= 30) && (_currentHour <= 15)) {
				_currentHour++;
			}
			else if ((_currentMin >= 30) && (_currentHour >= 15)) {
				_currentDateTime.setDate(_currentDateTime.getDate() + 1)
				_currentHour = 7;
			}

			let _currentDayBefore = _currentDateTime.getDay();

			if (_currentDayBefore == 0) {
				_currentDateTime.setDate(_currentDateTime.getDate() + 1)
			}
			else if (_currentDayBefore == 6) {
				_currentDateTime.setDate(_currentDateTime.getDate() + 2)
			}

			let _currentDate = _currentDateTime.getFullYear() + '/' + ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ("0" + _currentDateTime.getDate()).slice(-2);
			if (this.publicHolidays) {
				this.publicHolidays.forEach(holiday => {
					if (_currentDate == holiday) {
						_currentDateTime.setDate(_currentDateTime.getDate() + 1);

						let _currentDay = _currentDateTime.getDay();

						if (_currentDay == 0) {
							_currentDateTime.setDate(_currentDateTime.getDate() + 1)
						}
						else if (_currentDay == 6) {
							_currentDateTime.setDate(_currentDateTime.getDate() + 2)
						}

						_currentDate = _currentDateTime.getFullYear() + '/' + ("0" + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ("0" + _currentDateTime.getDate()).slice(-2);
						_currentHour = 7;
						_currentMin = 0;
					}
				});
			}

			let _currentDayAfter = _currentDateTime.getDay();

			if (_currentDayAfter == 0) {
				_currentDateTime.setDate(_currentDateTime.getDate() + 1)
			}
			else if (_currentDayAfter == 6) {
				_currentDateTime.setDate(_currentDateTime.getDate() + 2)
			}

			if (this.formTimePicker) {
				const item = <HTMLSelectElement>this.formTimePicker;
				const _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
				for (let i = item.options.length - 1; i >= 0; i--) {
					if (item.options[i].value != 'Anytime') {
						if ((item.options[i].value < _tmpTime) && (_enabledOptions == false)) {
							item.options[i].disabled = true;
						}
						else if (_enabledOptions == true) {
							item.options[i].disabled = false;
						}
					}
				}
			}

			return _currentDateTime;
		}
	}
}



// WEBPACK FOOTER //
// ./components/form-container/form-container.component.ts